import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Config";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";

/*
 * Printable Bus Financial Audit. Landscape, because the description column carries real
 * text ("Fuel (67.00 Ltr @ 313.80)") that is not worth truncating.
 */
function PrintBusAudit() {
  const AccessKey = localStorage.getItem("AccessKey");
  const UserID = localStorage.getItem("ID");
  const MemberType = localStorage.getItem("MemberType");

  const urlParams = new URLSearchParams(window.location.search);
  const fromDate = urlParams.get("from") || moment().startOf("year").format("YYYY-MM-DD");
  const toDate = urlParams.get("to") || moment().format("YYYY-MM-DD");
  const vehicle = urlParams.get("vehicle") || "";

  const [loading, setLoading] = useState(true);
  const [lines, setLines] = useState([]);
  const [totals, setTotals] = useState({ income: 0, expense: 0, net: 0 });

  useEffect(() => {
    document.title = "Bus Financial Audit Report";

    axios({
      method: "post",
      url: config.base_url + "TransportReport/GetVehicleLedger",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType: MemberType || "Admin",
        SchoolID: 1,
        Vehicle_ID: vehicle ? parseInt(vehicle, 10) : 0,
        From_Date: fromDate,
        To_Date: toDate,
      },
    })
      .then((res) => {
        if (res.data.status_code === 1) {
          setLines(res.data.ListofRecords || []);
          setTotals({
            income: res.data.TotalIncome || 0,
            expense: res.data.TotalExpense || 0,
            net: res.data.NetBalance || 0,
          });
        }
      })
      .catch(() => setLines([]))
      .finally(() => setLoading(false));
  }, [AccessKey, UserID, MemberType, vehicle, fromDate, toDate]);

  const money = (n) =>
    n === null || n === undefined || n === 0
      ? "-"
      : Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 });

  const renderRows = () => {
    const out = [];
    let lastVehicle = null;

    lines.forEach((l, i) => {
      if (l.Vehicle_ID !== lastVehicle) {
        lastVehicle = l.Vehicle_ID;
        out.push(
          <tr key={`h-${l.Vehicle_ID}`}>
            <td colSpan="6" style={{ fontWeight: 700, background: "#f1f1f1" }}>
              Bus No: {l.Registration_No}
            </td>
          </tr>
        );
      }

      out.push(
        <tr key={`${l.Vehicle_ID}-${i}`}>
          <td>{moment(l.Line_Date).format("DD-MMM-YYYY")}</td>
          <td>{l.Line_Type}</td>
          <td>{l.Description}</td>
          <td style={{ textAlign: "right" }}>{money(l.Income)}</td>
          <td style={{ textAlign: "right" }}>{money(l.Expense)}</td>
          <td style={{ textAlign: "right", fontWeight: 600 }}>{money(l.Balance)}</td>
        </tr>
      );
    });

    return out;
  };

  return (
    <>
      {loading ? (
        <div className="text-center p-5">
          <Spinner animation="border" role="status" />
        </div>
      ) : (
        <Page orientation="landscape" size="A4">
          <PrintHeader title="Bus Financial Audit Report" />

          <div style={{ fontSize: "10pt", marginBottom: "8px" }}>
            <b>Period:</b> {moment(fromDate).format("DD-MMM-YYYY")} to{" "}
            {moment(toDate).format("DD-MMM-YYYY")}
            {"   |   "}
            <b>Income:</b> Rs. {money(totals.income)}
            {"   |   "}
            <b>Expense:</b> Rs. {money(totals.expense)}
            {"   |   "}
            <b>Net:</b> Rs. {money(totals.net)}
          </div>

          <table className="table table-sm table-bordered">
            <thead>
              <tr>
                <th style={{ width: "12%" }}>Date</th>
                <th style={{ width: "12%" }}>Type</th>
                <th>Description</th>
                <th style={{ width: "13%", textAlign: "right" }}>Income</th>
                <th style={{ width: "13%", textAlign: "right" }}>Expense</th>
                <th style={{ width: "13%", textAlign: "right" }}>Balance</th>
              </tr>
            </thead>
            <tbody>
              {lines.length === 0 ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: "center" }}>
                    No money moved against this selection in the period
                  </td>
                </tr>
              ) : (
                renderRows()
              )}
            </tbody>
            {lines.length > 0 ? (
              <tfoot>
                <tr style={{ fontWeight: 700 }}>
                  <td colSpan="3" style={{ textAlign: "right" }}>
                    TOTALS
                  </td>
                  <td style={{ textAlign: "right" }}>Rs. {money(totals.income)}</td>
                  <td style={{ textAlign: "right" }}>Rs. {money(totals.expense)}</td>
                  <td style={{ textAlign: "right" }}>Rs. {money(totals.net)}</td>
                </tr>
              </tfoot>
            ) : null}
          </table>
        </Page>
      )}
    </>
  );
}

export default PrintBusAudit;
